import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  const phone = "393482478661";
  const text = encodeURIComponent("Ciao Valeria, vorrei avere informazioni sui tuoi servizi.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Scrivimi su WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/10 hover:scale-110 transition-transform"
    >
      <MessageCircle size={24} strokeWidth={1.8} />
      <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-white animate-ping" />
      <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#25D366] border-2 border-white" />
    </a>
  );
}
